































































































































import { Component } from 'vue-property-decorator';
import TemplateParamsFilter from "@/components/Settings/TemplateParams/TemplateParamsFilter.vue";
import {ScrollButton} from "wings-ui-components";
import {Getter} from "vuex-class";
import {TemplateParamsItem} from "@/store/settings/template_params/types";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";

@Component({components:{TemplateParamsFilter,ScrollButton}})
export default class TemplateParams extends BaseItemsPage<TemplateParamsItem> {
  @Getter("templateParams") templateParams: any;
  private is_show_filter = false;
  currentSort= "id";
  currentSortOrder= "desc";

  tableFields = [
    'id',
    'name',
    'partner_name',
    'transport_name',
    'type',
    'limitations'
  ];

  getData(): any {
    return this.templateParams;
  }
}
